import { render, staticRenderFns } from "./MontagemCargaObs.vue?vue&type=template&id=42cb4d12"
import script from "./MontagemCargaObs.vue?vue&type=script&lang=js"
export * from "./MontagemCargaObs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports